// Phase P-fix (2026-10) · Sales-order status badge.
// Thin wrapper over the existing shadcn Badge primitive with four
// semantic variants mapped to the status families requested by the
// owner. Scope-locked: used ONLY by AdminSalesOrders list + detail;
// no broad design-system refactor.
import React from "react";

const MAP = {
  // Payment statuses
  paid:            { tone: "green",  label: "Paid" },
  overpaid:        { tone: "green",  label: "Overpaid" },
  partially_paid:  { tone: "yellow", label: "Partially Paid" },
  unpaid:          { tone: "red",    label: "Unpaid" },
  // Fulfillment statuses
  unfulfilled:     { tone: "red",    label: "Unfulfilled" },
  preparing:       { tone: "yellow", label: "Preparing" },
  ready_pickup:    { tone: "yellow", label: "Ready for Pickup" },
  ready_ship:      { tone: "yellow", label: "Ready to Ship" },
  picked_up:       { tone: "green",  label: "Picked Up" },
  shipped:         { tone: "green",  label: "Shipped" },
  fulfilled:       { tone: "green",  label: "Fulfilled" },   // legacy
  // Order statuses
  open:            { tone: "gray",   label: "Open" },
  completed:       { tone: "green",  label: "Completed" },
  cancelled:       { tone: "gray",   label: "Cancelled" },
  refunded:        { tone: "gray",   label: "Refunded" },
};

const TONES = {
  green:  "bg-emerald-100 text-emerald-800 border-emerald-300",
  yellow: "bg-amber-100   text-amber-800   border-amber-300",
  red:    "bg-rose-100    text-rose-800    border-rose-300",
  gray:   "bg-slate-100   text-slate-700   border-slate-300",
};

export function SalesOrderStatusBadge({ value, kind = "generic", className = "" }) {
  // Legacy pickup orders that stayed on "fulfilled" render as "Picked Up"
  // when the operator-captured fulfillment intent proves it was a pickup.
  // Nothing is mutated on disk — this is a display-only fallback.
  const info = MAP[value] || { tone: "gray", label: String(value || "—") };
  const tone = TONES[info.tone] || TONES.gray;
  return (
    <span
      data-testid={`sales-order-badge-${kind}-${value || "unknown"}`}
      className={
        "inline-flex items-center rounded-full border px-2 py-0.5 " +
        "text-[10px] font-bold uppercase tracking-wide " + tone + " " + className
      }
    >
      {info.label}
    </span>
  );
}

export default SalesOrderStatusBadge;
